import styled from "styled-components";
import Header from "../components/header/Header";
//import TourGuidesContent from "../components/bookings_manager/tour_guides/content/TourGuidesContent";
import ExternalAssignmentsContent from "@/components/bookings_manager/tour_guides/content/external_assignments/ExternalAssignmentsContent";
import { useNavigate } from "react-router-dom";

//------------------------------------------------------------------------

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

//------------------------------------------------------------------------

const TourGuidesPlanner = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header
        text={"External Assignments"}
        redirectFn={() => {
          navigate("/home");
        }}
      />
      <ContentContainer>
        {/* <TourGuidesContent /> */}
        <ExternalAssignmentsContent />
      </ContentContainer>
    </Container>
  );
};

export default TourGuidesPlanner;
